import { getDateFromString } from '@lx/shared/utils';
import { z } from 'zod';

/**
 * Custom date schema that coerces strings to Date objects using getDateFromString.
 * Returns undefined for invalid dates instead of throwing, allowing the app
 * to fall back to a calculated default date.
 */
export const optionalDateSchema = z
  .string()
  .optional()
  .transform((val) => {
    if (!val) {
      return undefined;
    }
    try {
      return getDateFromString(val);
    } catch {
      // Invalid date format - return undefined to trigger fallback behavior
      return undefined;
    }
  });
